import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import defaultImage from "../../../assets/images/default.jpg";

const SellerDocumentsDialog = ({ open, onClose, sellerData }) => {
  const documents = [
    {
      label: "Government ID",
      url: sellerData?.govId,
      icon: "fa-id-card",
    },
    {
      label: "Registration Certificate",
      url: sellerData?.registrationCert,
      icon: "fa-certificate",
    },
    {
      label: "Address Proof",
      url: sellerData?.addressProof,
      icon: "fa-map-marker-alt",
    },
  ];

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = defaultImage;
  };

  const openInNewTab = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: "#ffffff",
          color: "#333",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <DialogTitle
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #e5e7eb",
          padding: "16px 24px",
          backgroundColor: "#fff",
        }}
      >
        <div>
          <span style={{ fontSize: "18px", fontWeight: "600", color: "#1f2937" }}>
            Seller Documents
          </span>
          <p style={{ fontSize: "14px", color: "#6b7280", margin: "4px 0 0 0" }}>
            {sellerData?.firstName} {sellerData?.lastName} - {sellerData?.businessName}
          </p>
        </div>
        <IconButton onClick={onClose} style={{ color: "#6b7280" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ padding: "24px", backgroundColor: "#f9fafb" }}>
        <div className="row">
          {documents.map((doc, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  padding: "16px",
                  height: "100%",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <i
                    className={`fas ${doc.icon}`}
                    style={{
                      fontSize: "18px",
                      marginRight: "10px",
                      color: "#D4A418",
                    }}
                  ></i>
                  <span style={{ fontWeight: "600", color: "#1f2937" }}>{doc.label}</span>
                </div>
                {doc.url ? (
                  <div>
                    <img
                      src={doc.url}
                      alt={doc.label}
                      style={{
                        width: "100%",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "6px",
                        cursor: "pointer",
                        marginBottom: "10px",
                        border: "1px solid #e5e7eb",
                      }}
                      onClick={() => openInNewTab(doc.url)}
                      onError={handleImageError}
                    />
                    <button
                      onClick={() => openInNewTab(doc.url)}
                      style={{
                        width: "100%",
                        padding: "10px",
                        backgroundColor: "#D4A418",
                        border: "none",
                        borderRadius: "6px",
                        color: "#000",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "background-color 0.2s",
                      }}
                      onMouseOver={(e) => e.target.style.backgroundColor = "#c49615"}
                      onMouseOut={(e) => e.target.style.backgroundColor = "#D4A418"}
                    >
                      <i className="fas fa-external-link-alt me-2"></i>
                      View Full Size
                    </button>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "150px",
                      backgroundColor: "#f3f4f6",
                      borderRadius: "6px",
                      color: "#9ca3af",
                      border: "2px dashed #d1d5db",
                    }}
                  >
                    <i
                      className="fas fa-file-image"
                      style={{ fontSize: "32px", marginBottom: "8px" }}
                    ></i>
                    <span style={{ fontWeight: "500" }}>Not Uploaded</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Seller Logo */}
        {sellerData?.logo && (
          <div style={{ marginTop: "16px" }}>
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                padding: "16px",
                border: "1px solid #e5e7eb",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <i
                  className="fas fa-store"
                  style={{
                    fontSize: "18px",
                    marginRight: "10px",
                    color: "#D4A418",
                  }}
                ></i>
                <span style={{ fontWeight: "600", color: "#1f2937" }}>Business Logo</span>
              </div>
              <div className="d-flex align-items-center">
                <img
                  src={sellerData.logo}
                  alt="Business Logo"
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    cursor: "pointer",
                    marginRight: "16px",
                    border: "1px solid #e5e7eb",
                  }}
                  onClick={() => openInNewTab(sellerData.logo)}
                  onError={handleImageError}
                />
                <button
                  onClick={() => openInNewTab(sellerData.logo)}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "#D4A418",
                    border: "none",
                    borderRadius: "6px",
                    color: "#000",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "background-color 0.2s",
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = "#c49615"}
                  onMouseOut={(e) => e.target.style.backgroundColor = "#D4A418"}
                >
                  <i className="fas fa-external-link-alt me-2"></i>
                  View Full Size
                </button>
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SellerDocumentsDialog;
